<script lang="ts" setup>
  import { useId } from 'vue';

  defineProps<{ gameCode: number | string }>();

  const labelId = useId();
  const valueId = useId();
</script>

<template>
  <div class="game-code">
    <div :id="labelId" class="game-code-label">game code</div>
    <h1 :id="valueId" :aria-labelledby="`${labelId} ${valueId}`" class="game-code-value">{{ gameCode }}</h1>
  </div>
</template>

<style scoped>
  .game-code {
    max-width: var(--control-max-width);
    text-align: center;
    width: 100%;
  }

  .game-code-label {
    color: var(--color-text-muted);
    font-size: var(--game-code-label-size, var(--font-size-sm));
    letter-spacing: 0.1rem;
    margin-bottom: var(--game-code-label-margin, 0.2rem);
    text-transform: uppercase;
  }

  .game-code-value {
    color: var(--color-primary);
    font-family: var(--font-code);
    font-size: var(--game-code-value-size, var(--font-size-3xl));
    font-weight: var(--font-weight-strong);
    line-height: 1;
    margin: 0;
  }
</style>
